module.exports = __webpack_public_path__ + "static/media/Sama_logo.f7f41198.png";